<template>
  <scoped>
    <table v-if="items">
      <thead>
        <tr>
          <th>
            Type
          </th>
          <th>
            Trademark
          </th>
          <th>
            Name
          </th>
          <th>
            Price
          </th>
          <th>
            Currency
          </th>
        </tr>
      </thead>
      <tbody v-if="items.length > 0">
        <tr
          v-for="(deliverable, index) in items"
          :key="deliverable.id"
          :class="{'selected' : selectedIndex == index}"
          @click="select(index)"
        >
          <td>
            {{ deliverable.type }}
          </td>
          <td>
            <template v-if="deliverable.trademark">
              {{ deliverable.trademark.name }}
            </template>
          </td>
          <td>
            {{ deliverable.name }}
          </td>
          <td>
            <template v-if="deliverable.unitPrice && deliverable.unitPrice.gross">
              {{ Number(deliverable.unitPrice.gross).toFixed(2) }}
            </template>
          </td>
          <td>
            {{ deliverable.currency }}
          </td>
        </tr>
      </tbody>
    </table>
  </scoped>
</template>

<script setup lang="ts">
  import {Deliverable} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {nextTick} from "vue"

  defineProps({
    items: {
      default: null,
      required: true,
      type: Array<Deliverable>
    }
  })

  const emits = defineEmits(["select"])

  const selectedIndex = defineModel("selectedIndex", {
    default: null,
    required: false,
    type: Number
  })

  async function select(index: number) {
    selectedIndex.value = index
    await nextTick()
    emits("select")
  }
</script>

<style scoped>
  table {
    > tbody {
      > tr {
        &:hover {
          background-color: var(--theme-color-secondary);
          color: var(--color-white);
          cursor: pointer;
        }

        &.selected {
          background-color: var(--theme-color-secondary);
          color: var(--color-white);
          cursor: default;
        }
      }
    }
  }
</style>
